import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrderService} from "../../../../services/OrderService";
import {CartService} from "../../../../services/CartService";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {PopoverController} from "@ionic/angular";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {Events} from "../../../../../framework/providers/events";
import {Company} from "../../../../../framework/model/core/company/company";

@Component({
    selector: 'app-saved-cart',
    templateUrl: './saved-cart.component.html',
    styleUrls: ['./saved-cart.component.scss']
})
export class SavedCartComponent {

    @Input()
    public onClose: any;

    public savedCarts: any;
    public company: Company;

    @Input()
    public isPopup: boolean;

    public prefix: string = 'savedCart_' + Math.floor((Math.random() * 1000) + 1);

    constructor(public orderService: OrderService,
                public cartService: CartService,
                public events: Events,
                public tools: ModelToolsProvider,
                public modelProvider: ModelProvider,
                public popoberCtrl: PopoverController) {
    }

    ngOnInit() {
        this.events.subscribe('appPriceSets', (res) => {
            this.initData();
        }, this.prefix);

        this.initData();
    }

    ngOnDestroy()
    {
        this.events.unsubscribe('appPriceSets', this.prefix);
    }

    initData() {
        this.company = this.orderService.getCompany();

        this.modelProvider.custom('getSavedCart', {'setPrefix':true}).then((res)=>{
            this.savedCarts = res['res'];
        })

    }

    setCart(cartData) {
        this.orderService.changeAgentCompany(null, cartData['company_id'], true, 'saved_cart', true);
        this.cartService.clearCart();
        this.cartService.updateData(cartData['data']);
        this.tools.goTo('cart');

        this.close()

        // this.orderService.initCart();
        // this.orderService.loadCartFromData({
        //     'cartId': cartData['cartId'],
        //     'cart': cartData['cart'],
        //     'cartData': this.orderService.cartData
        // }, false);
        // this.orderService.doCartCalc();
    }

    removeCart(cart) {
        let me = this;
        this.tools.yesOrNoAlert(function () {
            me.modelProvider.customPost('closeSavedCart', {'id': cart['_id']})
            cart['open'] = false;
        }, {'title': this.tools.getTranslate('removeSavedCart'), 'message': this.tools.getTranslate('areYouSure')});
    }

    close() {
        if (!this.isPopup) return
        this.onClose();
        this.popoberCtrl.dismiss();
    }
}
